"use strict";
exports.__esModule = true;
exports.PriorityLabels = exports.PriorityIconsMap = exports.PriorityColorMap = exports.Priorities = void 0;
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
exports.Priorities = [
    0,
    1,
    2,
    3,
    4,
];
exports.PriorityColorMap = {
    0: "#d32f2f",
    1: "#f57c00",
    2: "#1976d2",
    3: "#00796b",
    4: "#388e3c"
};
exports.PriorityIconsMap = {
    0: pro_light_svg_icons_1.faChevronsUp,
    1: pro_light_svg_icons_1.faChevronUp,
    2: pro_light_svg_icons_1.faEquals,
    3: pro_light_svg_icons_1.faChevronDown,
    4: pro_light_svg_icons_1.faChevronsDown
};
exports.PriorityLabels = {
    work: {
        0: "P0",
        1: "P1",
        2: "P2",
        3: "P3",
        4: "P4"
    },
    solo: {
        0: "Super Important",
        1: "Important",
        2: "Kinda Important",
        3: "Not Important",
        4: "Whenever"
    }
};
